import React, { useState } from 'react';
import { useSceneUpdate } from '../../hooks/useSceneUpdate';
import './InteractiveSceneMusic.css';
import CustomSelect from '../CustomSelect';

const InteractiveSceneMusic = ({
  novelId, sceneId, scene, setScene, novel, loading, setLoading, error, setError, isProduction = false, sceneType = 'interactive'
}) => {
  const [editingMusic, setEditingMusic] = useState(false);
  const [musicFormData, setMusicFormData] = useState({ music_mix_id: '', start_asset_music_id: '' });
  const { saveScene } = useSceneUpdate(novelId, sceneId, isProduction, setScene, setLoading, sceneType);

  const handleEditMusic = () => {
    setMusicFormData({
      music_mix_id: scene?.music?.music_mix_id || '',
      start_asset_music_id: scene?.music?.start_asset_music_id || ''
    });
    setEditingMusic(true);
  };

  const handleSaveMusic = async () => {
    if (!musicFormData.music_mix_id || !musicFormData.start_asset_music_id) {
      setError('Выберите музыкальный микс и начальный трек');
      return;
    }
    setError(null);
    const success = await saveScene(
      { ...scene, music: { music_mix_id: musicFormData.music_mix_id, start_asset_music_id: musicFormData.start_asset_music_id } },
      'Музыка успешно сохранена!'
    );
    if (success) setEditingMusic(false);
  };

  const handleRemoveMusic = async () => {
    if (!window.confirm('Вы уверены, что хотите удалить музыку из этой сцены?')) return;
    await saveScene({ ...scene, music: null }, 'Музыка успешно удалена!');
  };

  const handleCancelMusicEdit = () => {
    setEditingMusic(false);
    setMusicFormData({ music_mix_id: '', start_asset_music_id: '' });
    setError(null);
  };

  const getMusicMixName = (musicMixId) => novel?.music_mixes?.find(mix => mix.id === musicMixId)?.name || 'Неизвестный микс';
  const getMusicAssetName = (musicAssetId) => novel?.assets?.musics?.find(asset => asset.id === musicAssetId)?.name || 'Неизвестный трек';
  const getSelectedMusicMix = () => novel?.music_mixes?.find(mix => mix.id === musicFormData.music_mix_id) || null;

  return (
    <div className="ismu-wrap">
      <div className="ismu-header">
        <h3>Музыка сцены</h3>
        <p className="ismu-help">Настройте фоновую музыку, которая будет играть во время этой сцены</p>
      </div>

      {error && <div className="ismu-error">{error}</div>}

      {editingMusic && (
        <div className="ismu-overlay">
          <div className="ismu-modal">
            <h3 className="ismu-modal-title">Редактировать музыку</h3>

            <div className="ismu-form-group">
              <label className="ismu-label">Музыкальный микс:</label>
              <CustomSelect
                value={musicFormData.music_mix_id}
                onChange={(e) => setMusicFormData({ ...musicFormData, music_mix_id: e.target.value, start_asset_music_id: '' })}
                className="app-select" disabled={loading} required
              >
                <option value="">Выберите музыкальный микс</option>
                {novel?.music_mixes?.map((musicMix) => (
                  <option key={musicMix.id} value={musicMix.id}>{musicMix.name}</option>
                ))}
              </CustomSelect>
            </div>

            <div className="ismu-form-group">
              <label className="ismu-label">Начальная музыка:</label>
              <CustomSelect
                value={musicFormData.start_asset_music_id}
                onChange={(e) => setMusicFormData({ ...musicFormData, start_asset_music_id: e.target.value })}
                className="app-select" disabled={loading || !musicFormData.music_mix_id} required
              >
                <option value="">Выберите начальную музыку</option>
                {getSelectedMusicMix()?.music_asset_ids?.map((musicAssetId) => (
                  <option key={musicAssetId} value={musicAssetId}>{getMusicAssetName(musicAssetId)}</option>
                ))}
              </CustomSelect>
            </div>

            <div className="ismu-form-actions">
              <button type="button" onClick={handleSaveMusic} disabled={loading} className="ismu-btn-primary">
                {loading ? 'Загрузка...' : 'Сохранить'}
              </button>
              <button type="button" onClick={handleCancelMusicEdit} disabled={loading} className="ismu-btn-cancel">
                Отменить
              </button>
            </div>
          </div>
        </div>
      )}

      {scene?.music && scene.music.music_mix_id && (
        <div className="ismu-card">
          <div className="ismu-card-head">
            <h4 className="ismu-card-name">Музыка: {getMusicMixName(scene.music.music_mix_id)}</h4>
          </div>
          <div className="ismu-card-body">
            <div className="music-details">
              <p><strong>Начальная музыка:</strong> {getMusicAssetName(scene.music.start_asset_music_id)}</p>
            </div>
          </div>
        </div>
      )}

      <div className="ismu-add-wrap">
        <button className="ismu-add-btn" onClick={handleEditMusic} disabled={loading}>
          <span className="button-icon">🎵</span>
          {scene?.music && scene.music.music_mix_id ? 'Редактировать музыку' : 'Добавить музыку'}
        </button>
        {scene?.music && scene.music.music_mix_id && (
          <button className="ismu-btn-delete" onClick={handleRemoveMusic} disabled={loading}>
            Удалить музыку
          </button>
        )}
      </div>
    </div>
  );
};

export default InteractiveSceneMusic;
